import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { speakingPart3Data, getDataForDifficulty } from './data/skills/speaking/speakingPart3';

export default function SpeakingPart3() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : speakingPart3Data)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
